import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';
import App from './App';
import './i18n';
import { debugLog } from './utils/logger';

// Controllo dell'ambiente per il debug
if (process.env.NODE_ENV === 'development') {
    debugLog('⚡ Modalità sviluppo attivata!');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
